import React from 'react';
import { FONT_SERIF, useTheme } from '../theme';

/** Q-loggan + "venari" i serif, samma ordmärke som i menyraden. `size` = höjd i px. */
export function BrandLogo({ size = 30, style }: { size?: number; style?: React.CSSProperties }) {
  const T = useTheme();
  return (
    <div role="img" aria-label="Qvenari" style={{ display: 'inline-flex', alignItems: 'center', gap: 2, userSelect: 'none', ...style }}>
      <img src="/qvenari-logo.png" alt="" style={{ height: size, width: 'auto', objectFit: 'contain', flexShrink: 0 }} />
      <span style={{ fontFamily: FONT_SERIF, fontSize: size, color: T.text, letterSpacing: '-0.5px', lineHeight: 1, marginTop: Math.round(size * 0.13), whiteSpace: 'nowrap' }}>venari</span>
    </div>
  );
}
